<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-cg-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-cg-badge">Gift voucher noCTA</span>

  <div class="cr-cg-row">
    <div
      class="cr-cg-dropzone"
      [appInlineMedia]="block.variables?.['ConciergeImage']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'ConciergeImage')"
    >
      <a *ngIf="block.variables?.['ConciergeImage']; else emptyPreview" [href]="imagePreviewHref" target="_blank" rel="noopener">
        <img [src]="block.variables?.['ConciergeImage']" [alt]="block.variables?.['ConciergeImageAlt'] || ''" />
      </a>

      <ng-template #emptyPreview>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>

    <div class="cr-cg-content">
      <span
        class="cr-cg-heading"
        [appInlineEdit]="block.variables?.ConciergeHeading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert heading"
        (inlineEditChange)="onChange($event, 'ConciergeHeading')"
      ></span>

      <span
        class="cr-cg-text"
        [appInlineEdit]="block.variables?.ConciergeText ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert text"
        [inlineEditMultiline]="true"
        (inlineEditChange)="onChange($event, 'ConciergeText')"
      ></span>
    </div>
  </div>
</div>

<!-- Right panel: real edit form -->
<div class="cr-cg-edit" *ngIf="!isPreview">
  <div class="cr-cg-field-row">
    <span class="cr-cg-field-label">Image</span>
    <span
      class="cr-cg-toggle"
      [class.cr-cg-toggle-on]="imageAsUpload"
      role="button"
      tabindex="0"
      [title]="imageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleImageMode()"
      (keydown.enter)="toggleImageMode()"
      (keydown.space)="toggleImageMode()"
    ></span>
  </div>
  <div class="cr-cg-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['ConciergeImage'] ?? ''"
      (handleOnChange)="onChange($event, 'ConciergeImage')"
      [placeholder]="imagePlaceholder"
      variable="ConciergeImage"
      [isImage]="imageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-cg-empty-overlay" *ngIf="imageAsUpload && !block.variables?.['ConciergeImage']">
      <div class="cr-cg-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-cg-title">Upload image</div>
      <div class="cr-cg-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-cg-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['ConciergeImageHref'] ?? ''"
      (handleOnChange)="onChange($event, 'ConciergeImageHref')"
      [placeholder]="imageHrefPlaceholder"
      variable="ConciergeImageHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'ConciergeImageHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['ConciergeImageHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="alt"
    [blockData]="block.variables?.['ConciergeImageAlt'] ?? ''"
    (handleOnChange)="onChange($event, 'ConciergeImageAlt')"
    [placeholder]="imageAltPlaceholder"
    [maxLength]="500"
    variable="ConciergeImageAlt"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['ConciergeHeading'] ?? ''"
    (handleOnChange)="onChange($event, 'ConciergeHeading')"
    [placeholder]="headingPlaceholder"
    [maxLength]="500"
    variable="ConciergeHeading"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.['ConciergeText'] ?? ''"
    (handleOnChange)="onChange($event, 'ConciergeText')"
    [placeholder]="textPlaceholder"
    [maxLength]="4000"
    variable="ConciergeText"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
